
export default {
	1: {
		id: 1,
		name: 'Red',
		usedby: 'Zombie, Vampire',
		hide: false,
	},
	2: {
		id: 2,
		name: 'Red',
		usedby: 'NA',
		hide: true,
	},
	3: {
		id: 3,
		name: 'Red',
		usedby: 'NA',
		hide: true,
	},
	4: {
		id: 4,
		name: 'Dark Grey',
		usedby: 'Skeletons',
		hide: false,
	},
	5: {
		id: 5,
		name: 'Black',
		usedby: 'Repaer, Ibzan',
		hide: false,
	}
}